<template>
  <p class="read-more-inline__wrapper">
    <span v-html="text" />
    <button class="btn inline-link" @click="toggle" v-text="label" />
  </p>
</template>

<script>
export default {
  name: 'ReadMoreInline',

  data() {
    return {
      showFull: false,
      fullText: this.$mountEl.dataset.fullText,
      excerpt: this.$mountEl.dataset.excerpt,
      texts: theme_vars.readMore,
    };
  },

  computed: {
    text() {
      return this.showFull ? this.fullText : this.excerpt;
    },

    label() {
      return this.showFull ? this.texts.hideText : this.texts.readMore;
    },
  },

  methods: {
    toggle() {
      this.showFull = !this.showFull;
    },
  },
};
</script>
